import { ExchangeExecutor } from '../../Executors';
import { useFastRedeem } from './hooks/useFastRedeem';
import { useFastRedeemQuote } from './hooks/useFastRedeemQuote';

export const FastRedeemExecutor: ExchangeExecutor = {
  useQuote: useFastRedeemQuote,
  useSwap: useFastRedeem,
  getSwapArgs: ({ inputToken, outputToken, inputAmount, quoteData, address }) => ({
    inputToken,
    outputToken,
    inputAmount,
    minOutputAmount: quoteData.formattedAmountOut,
    adapter: quoteData.bestCandidate.adapter,
    adapterData: quoteData.bestCandidate.data,
    receiver: address,
  }),
};
